import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { PortalServiceDetailsMapperService } from './portal-service-details-mapper.service';
import { PortalServiceDetailsCustomDetailsResponse } from '../../models/portal/GetAllServicesDetailResponse';

@Injectable({
  providedIn: 'root',
})
export class ServiceMetadataGetCustomDetailService {
  private REST_API_SERVER_NEW =
    environment.gateway +
    environment.websiteUrl +
    'GetCustomDetails?attr_digitalservice={attr_digitalservice}&languageId={languageId}';

  constructor(
    private httpClient: HttpClient,
    private serviceDetailsMapper: PortalServiceDetailsMapperService
  ) {}

  public getServiceMetadataCustomDetails(
    serviceNumber: string,
    lang: string
  ): Observable<PortalServiceDetailsCustomDetailsResponse> {
    const languageId = this.serviceDetailsMapper.resolveLanguageId(lang);

    return this.httpClient
      .get<PortalServiceDetailsCustomDetailsResponse>(
        this.REST_API_SERVER_NEW.replace(
          '{attr_digitalservice}',
          serviceNumber
        ).replace('{languageId}', languageId.toString())
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error(
        '[ServiceDetailByDigitalNumberService] Client Side Error',
        errorResponse.error.message
      );
    } else {
      console.error(
        '[ServiceDetailByDigitalNumberService] Server Side Error',
        errorResponse.error.message
      );
    }

    return throwError(
      'There is a problem with the service. we are notified & working on it. please try again later'
    );
  }
}
